import { render } from "./DocProduct.vue?vue&type=template&id=5a7d53bc&scoped=true&ts=true"
import script from "./DocProduct.vue?vue&type=script&lang=ts"
export * from "./DocProduct.vue?vue&type=script&lang=ts"

import "./DocProduct.vue?vue&type=style&index=0&id=5a7d53bc&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7d53bc"]])

export default __exports__